import axios from 'axios';
import qs from 'qs';

const mockUrl = 'http://ar.lanxiongtiyu.com/lxtopic/lanxiong/';

const BASE_URL = mockUrl;

const request = axios.create({
  baseURL: `${BASE_URL}/`
});

request.interceptors.request.use(
  config => {
    if (config.method.toLowerCase() === 'post') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.data = qs.stringify(config.data);
    } else {
      config.headers['Content-Type'] = 'application/json';
      config.params = config.data;
      config.data = null;
    }

    return config;
  },
  err => {
    const error = {
      type: 'connection',
      url: window.location.href,
      err
    };

    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    const { data } = response;
    if (data.code === 401) {
      return Promise.reject(data.message);
    } else {
      return data;
    }
  },
  err => {
    return Promise.reject(err);
  }
);

export default request;
